
/* injects from baggage-loader */

const subscribeFormDirective = angular.module('subscribeForm.setting', []);

subscribeFormDirective.directive("subscribeFormSetting", [
  "$window", "$timeout", "$compile", "$templateCache", "ns", "translitService", "$rootScope", "$filter", "SubscribeFormManager",
  ($window, $timeout, $compile, $templateCache, ns, translitService, $rootScope, $filter, SubscribeFormManager) => {
    return {
      restrict: "A",
      scope: {
        data: "=ngModel"
      },
      link: (scope, element, attrs, ngModel) => {

        const id = attrs.widgetId;
        const widgetElWrapper = angular.element("[data-block-id=" + id + "]").find(ns.widgetWrapperClass);
        const SUM_FIELD = 'orderData[bill_sum]';

        scope.accordion = {
          show_form: false,
          show_parent_button: false,
          show_button: false,
          show_action: false
        };

        scope.data = SubscribeFormManager.updateOptions(scope.data);

        scope.data.stripe_key = window.justclick.stripePublicKey;
        scope.data.product_currency = window.justclick.currencySymbol;
        scope.data.service_domain = window.justclick.serviceDomain || "";
        scope.data.after_activate_url_placeholder = `https://${window.location.host}/subscribe/confirmdone/`;
        scope.data.redirect_url_placeholder = `https://${window.location.host}/subscribe/done/`;

        if (Editor.mode === 'form.page.editor' && !!window.justclick.disableFormSettings) {
          scope.$parent.openTab('blockDesign');
        }


        const findFileldIndexByAttr = (fields, attribute) => {
          const field = _.filter(fields, attribute)[0];
          return fields.indexOf(field);
        };

        const setSelectedFirstProduct = (products) => {
          let i, index, len;
          let categoryIndex = 0;
          let results = [];
          for (index = i = 0, len = products.length; i < len; index = ++i) {
            const category = products[index];
            if (index === categoryIndex) {
              if (category.hasOwnProperty("goods")) {
                results.push((() => {
                  let j, len1;
                  let results1 = [];
                  const ref = category.goods;
                  for (index = j = 0, len1 = ref.length; j < len1; index = ++j) {
                    const good = ref[index];
                    if (index === 0) {
                      results1.push(good.selected = true);
                    } else {
                      results1.push(void 0);
                    }
                  }
                  return results1;
                })());
              } else {
                results.push(categoryIndex++);
              }
            } else {
              results.push(void 0);
            }
          }
          return results;
        };

        const getProductsArray = (goods) => {
          let productsArr = [];
          _.each(goods, (good) => {
            if (good.hasOwnProperty("name") && good.selected) {
              productsArr.push(good);
            }
            if (good.hasOwnProperty("goods") && good.goods.length > 0) {
              return productsArr = productsArr.concat(getProductsArray(good.goods));
            }
          });
          return productsArr;
        };

        const setSelectedOldProducts = (oldProducts, products) => {
          let i, index, len;
          let results = [];
          for (index = i = 0, len = products.length; i < len; index = ++i) {
            const product = products[index];
            results.push((() => {
              let j, len1;
              let results1 = [];
              for (j = 0, len1 = oldProducts.length; j < len1; j++) {
                const oldProduct = oldProducts[j];
                if (oldProduct.hasOwnProperty("name") && oldProduct.name === product.name && oldProduct.selected) {
                  product.selected = true;
                }
                if (oldProduct.hasOwnProperty("goods") && oldProduct.goods.length > 0 && product.hasOwnProperty("goods") && product.goods.length > 0) {
                  results1.push(setSelectedOldProducts(oldProduct.goods, product.goods));
                } else {
                  results1.push(void 0);
                }
              }
              return results1;
            })());
          }
          return results;
        };

        if (scope.data.frame_settings.products && scope.data.frame_settings.products.length === 0) {
          const indexSum = findFileldIndexByAttr(scope.data.form_fields_attributes, {name: SUM_FIELD});
          if (indexSum > -1 && !!window.justclick.currencySymbol && scope.data.form_fields_attributes[indexSum].title.indexOf(',') === -1) {
            scope.data.form_fields_attributes[indexSum].title = scope.data.form_fields_attributes[indexSum].title + ', ' + window.justclick.currencySymbol;
          }
          scope.data.frame_settings.products = angular.copy(window.justclick.groups);
          setSelectedFirstProduct(scope.data.frame_settings.products);
        } else {
          const oldCategories = angular.copy(scope.data.frame_settings.products);
          scope.data.frame_settings.products = angular.copy(window.justclick.groups);
          setSelectedOldProducts(oldCategories, scope.data.frame_settings.products);
        }

        scope.data.selected_products = getProductsArray(scope.data.frame_settings.products);
        scope.data.product_selected = scope.data.submit_action === "make_order";
        scope.data.handleRadioClick = (productSelected) => {
          scope.data.product_selected = productSelected;
        };

        let listeners = [];

        listeners.push(scope.$watch("data.frame_settings.products", (newVal) => {
          scope.data.selected_products = getProductsArray(newVal);
        }, true));

        listeners.push(scope.$watch("data.submit_action", (newVal) => {
          if (newVal === 'make_order') {
            scope.data.form_design = 'vertical';
          }
        }));

        scope.$on("$destroy", () => {
          _.each(listeners, (listener) => {
            listener();
          });
        });
      }
    };
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/modules_settings/subscribeForm/subscribeForm.directive.js